import React from 'react'
import { func, string, node, oneOfType } from 'prop-types'
import classNames from 'classnames'

const CardActions = ({
  children,
  className: classNameProp,
  component: Component,
  ...other
}) => {
  const className = classNames(
    'campus-card-actions',
    classNameProp
  )

  return (
    <div className={className} {...other}>
      {children}
      <style jsx>
        {`
          .campus-card-actions {
            display: flex;
            align-items: center;
          }
        `}
      </style>
    </div>
  )
}

CardActions.propTypes = {
  className: string,
  children: node,
  component: oneOfType([
    string,
    func,
  ]),
}

CardActions.defaultProps = {
  component: 'div',
}

export default CardActions
